import { render } from "./SalesforceSettings.vue?vue&type=template&id=3308b2aa&scoped=true"
import script from "./SalesforceSettings.vue?vue&type=script&lang=js"
export * from "./SalesforceSettings.vue?vue&type=script&lang=js"

import "./SalesforceSettings.vue?vue&type=style&index=0&id=3308b2aa&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3308b2aa"]])

export default __exports__